/**
 * Cite This For Me: Web Citer — citation generator
 *
 * Declares four web-accessible-resource groups to every origin with no
 * `use_dynamic_url`: `/images/*`, `/popup.htm`, `js/*` and `css/*`. Every bundled
 * icon, script and stylesheet is therefore fetchable from any page at a fixed URL.
 *
 * The 128px toolbar icon is the cleanest signal: it lives under the exposed
 * `/images/*` group and loads through `probeImage` with no CORS grant, so it survives
 * a strict page CSP.
 *
 * Manifest verified against version 2.7.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'nnnmhgkokpalnmbeighfomegjfkklkle';

export const citeThisForMe: ExtensionDefinition = {
  id: ID,
  name: 'Cite This For Me: Web Citer',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 400_000,
  notes:
    'Exposes /images, /popup.htm, js and css to every origin with no dynamic URL. ' +
    'The toolbar icon loads without a CORS grant, so detection is conclusive.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load images/icon-128.png via <img> — the toolbar icon, exposed to every origin ' +
        'and readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'images/icon-128.png'),
    },
    {
      id: 'war-cite-css',
      kind: 'web-accessible-resource',
      description: 'Fetch css/cite.css — a vendor-named stylesheet exposed to <all_urls>.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/cite.css'),
    },
    {
      id: 'war-contentscript-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/contentscript.js — the content script bundle, a third independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/contentscript.js'),
    },
  ],
};
